import _ from 'lodash';

export class DocumentForm {
    /** @type {string} */
    type = '';

    /** @type {?int} */
    completionAmount = null;

    /** @type {array} */
    questions = [];

    /**
     * @param {Object} obj
     * @returns {DocumentForm}
     */
    static fromArray(obj) {
        const clonedObj = _.cloneDeep(obj);

        if (clonedObj && clonedObj.questions && clonedObj.questions.length) {
            clonedObj.questions = clonedObj.questions.map(question => DocumentFormQuestion.fromArray(question));
        }

        return _.assign(new this, clonedObj || {});
    }

    /**
     * @param {string} type
     * @returns {boolean}
     */
    static isCustom(type) {
        return type === 'custom';
    }

    addQuestionEntry() {
        this.questions.push(DocumentFormQuestion.fromArray({
            title: '',
            key: this.questions.length + 1,
            questionType: 'radio',
            answers: [DocumentFormAnswer.fromArray({title: '', key: 1})],
            correctAnswer: 1,
        }));
    }

    /**
     * @param {int} questionIndex
     */
    deleteQuestionEntry(questionIndex) {
        this.questions.splice(questionIndex, 1);
        // reset keys so there is correct order
        this.questions = this.questions.map((q, i) => {
            q.key = i + 1;
            return q;
        });
    }
}

export class DocumentFormQuestion {
    /** @type {string} */
    title = '';

    /** @type {int} */
    key = 0;

    /** @type {string} */
    questionType = '';

    /** @type {DocumentFormAnswer[]} */
    answers = [];

    /** @type {int} */
    correctAnswer = 0;

    /**
     * @param {Object} obj
     * @returns {DocumentForm}
     */
    static fromArray(obj) {
        const clonedObj = _.cloneDeep(obj);

        if (clonedObj.answers && clonedObj.answers.length) {
            clonedObj.answers = clonedObj.answers.map(answer => DocumentFormAnswer.fromArray(answer));
        }

        return _.assign(new this, clonedObj || {});
    }

    addAnswerEntry() {
        this.answers.push(DocumentFormAnswer.fromArray({
            title: '',
            key: this.answers.length + 1,
        }));
    }

    /**
     * @param {int} answerIndex
     */
    deleteAnswerEntry(answerIndex) {
        this.answers.splice(answerIndex, 1);

        // if "correctselected" answer was removed, then reset correctAnswer.
        if (answerIndex + 1 == this.correctAnswer) {
            this.correctAnswer = 0;
        }

        // reset keys so there is correct order
        this.answers = this.answers.map((a, i) => {
            a.key = i + 1;
            return a;
        });
    }
}

export class DocumentFormAnswer {
    /** @type {string} */
    title = '';

    /** @type {int} */
    key = 0;

    /**
     * @param {Object} obj
     * @returns {DocumentForm}
     */
    static fromArray(obj) {
        return _.assign(new this, obj || {});
    }
}